import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  back: {
    id: 'topNavigation.back',
    defaultMessage: 'Takaisin',
  },
  edit: {
    id: 'topNavigation.edit',
    defaultMessage: 'Muokkaa',
  },
})
